<template>
    <v-app-bar
        id="app-bar-motonet"
        :density="$vuetify.display.lgAndUp ? 'prominent' : 'default'"
        shrink-on-scroll
        name="app-bar"
        scroll-behavior="elevate"
        :elevation="$vuetify.display.mdAndDown ? 1 : 0"
        :height="$vuetify.display.lgAndUp ? (shrink ? 42 + (infoHeight / 2) : 60 + (infoHeight / 2)) : ($vuetify.display.smAndDown ? ($page.props.simplePage ? 49 : 98) + (infoHeight) : 64 + (infoHeight))"
        :extension-height="$vuetify.display.lgAndUp ? (shrink ? 20 : 32) : 0"
        :class="{shrink}"
        v-scroll="onScroll"
    >
        <template v-if="!$page.props.simplePage && $vuetify.display.lgAndUp" v-slot:extension>
            <transition :name="shrink ? 'scroll-y-reverse-transition' : 'scroll-y-transition'">
                <info-bar v-if="$page.props.infobar?.text && !shrink" ref="infoBarRef" class="position-fixed"></info-bar>
            </transition>
            <div ref="appBar" class="w-100 h-100">
                <div id="extension-menu" class="d-flex align-center justify-center">
                    <v-menu
                        :open-on-hover="menuAttachment.hoverOpen"
                        :close-on-content-click="!menuAttachment.keepOpen"
                        :persistent="menuAttachment.persistent"
                        open-delay="10"
                        v-model="menuView"
                        location="bottom center"
                        :transition="menuAttachment.animate"
                        close-delay="10"
                        class="c-app-bar__menu"
                        :class="{'c-floating-menu': menuAttachment.floating}"
                        max-width="305"
                        :key="menuRefreshKey"
                        no-click-animation
                        @update:modelValue="overlayHide"
                    >
                        <template v-slot:activator="{ isActive, props }">
                            <div v-bind="menuAttachment.floating || scrolledToTop ? props : null" @click="scrollToTop"
                                 role="button"
                                 class="w-100 h-100 text-uppercase d-flex justify-space-between align-center bg-orange text-white tooltip-activator"
                            >
                                <div class="d-flex align-center">
                                    <v-icon :icon="mdiMenu" color="white" class="mx-4" />
                                    <div class="text-body-1 font-weight-bold">{{ $t('app-bar.browse_categories') }}
                                    </div>
                                </div>
                                <v-icon :icon="mdiChevronDown" color="white" class="mr-3 c-menu-icon"
                                        :class="isActive ? 'rotate' : ''" />
                            </div>
                        </template>
                        <v-list ref="listMenu" v-model:opened="menuModel"
                                class="c-dropdown-menu rounded-t-0 rounded-b-lg c-shadow py-0"
                                :elevation="0">
                            <float-menu
                                :menu-model="menuModel"
                                :menu="menu"
                                :sub-menu-width="subMenuWidth"
                                :active-menu="activeMenu">
                            </float-menu>
                        </v-list>
                    </v-menu>
                </div>
                <div class="d-flex align-center">
                    <Link :href="route('eshop.cartImport')" class="h-100">
                        <v-btn
                            class="text-body-1 font-weight-bold ml-4 h-100"
                            :prepend-icon="mdiCloudUploadOutline"
                        >
                            {{ $t('app-bar.product_import') }}
                        </v-btn>
                    </Link>
                    <Link
                        class="h-100"
                        :href="route('customer.shopping-lists')">
                        <v-btn
                            class="text-body-1 font-weight-bold ml-4 h-100"
                            rounded="0"
                            :prepend-icon="mdiContentSaveOutline"
                        >
                            {{ $t('app-bar.saved_products') }}
                        </v-btn>
                    </Link>
                </div>
                <div class="d-flex align-center justify-end">
                    <template v-if="$vuetify.display.xlAndUp">
                        <Link v-for="menu in sideMenu" :key="menu.link" :href="menu.link" class="h-100">
                            <v-btn
                                class="text-body-2 h-100"
                                rounded="0"
                            >
                                {{ menu.title }}
                            </v-btn>
                        </Link>
                    </template>
                    <template v-else>
                        <v-menu>
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    color="white"
                                    v-bind="props"
                                    size="40"
                                    :icon="mdiMenu"
                                    class="mr-2"
                                >
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-for="menu in sideMenu" :key="menu.link"
                                    :value="menu.link"
                                >
                                    <v-list-item-title @click="router.visit(menu.link)">{{ menu.title }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <v-expand-x-transition>
                        <v-btn v-if="$page.props.customer && $page.props.customer.is_dealer && shrink" :prepend-icon="priceHider?.pricesHidden ? mdiEyeOutline : mdiEyeOffOutline"
                               @click="priceHider.togglePrices()" density="compact" class=" text-body-2 font-weight-light">
                            <span v-if="!priceHider?.pricesHidden">{{ $t('app-bar.hide_prices') }}</span>
                            <span v-else>{{ $t('app-bar.show_prices') }}</span>
                        </v-btn>
                    </v-expand-x-transition>
                </div>
            </div>
        </template>
        <v-app-bar-title id="app-bar-title" class="pb-0"
                         :class="[$vuetify.display.lgAndUp ? 'pt-2 ml-0' : '', {'simple': $page.props.simplePage}]">
            <div
                v-if="!$page.props.simplePage && !shrink"
                id="app-bar-top"
                class="flex-1-1-100 text-body-2 text-grey-darken-1 font-weight-thin d-flex align-center pr-3 "
                :style="{'margin-top': `${infoHeight}px`}"
            >
                <span>{{ $t('app-bar.customer_service') }}</span>
                <v-icon :icon="mdiPhoneOutline" class="ml-3 mr-2"></v-icon>
                <a :href="'tel:' + $t('app-bar.customer_service_phone').replace(/ /g,'')"
                   class="font-weight-medium mr-2">{{ $t('app-bar.customer_service_phone') }}</a>
                <span>{{ $t('app-bar.customer_service_hours') }}</span>
                <div class="flex-grow-1"></div>
                <v-btn v-if="$page.props.customer && $page.props.customer.is_dealer" :prepend-icon="priceHider?.pricesHidden ? mdiEyeOutline : mdiEyeOffOutline"
                       @click="priceHider.togglePrices()" density="compact" class="mr-n4 text-body-2 font-weight-light">
                    <span v-if="!priceHider?.pricesHidden">{{ $t('app-bar.hide_prices') }}</span>
                    <span v-else>{{ $t('app-bar.show_prices') }}</span>
                </v-btn>
            </div>
            <div
                id="app-bar-logo"
                :style="{'margin-top': $vuetify.display.mdAndDown ? `${infoHeight}px` : ''}"
            >
                <Link href="/" class="text-decoration-none d-inline-flex" style="flex: 0 1 200px;">
                    <v-img :src="logo.src" :alt="logo.alt" :aspect-ratio="25/8" :cover="false" :height="$vuetify.display.mdAndUp ? '64px' : '47.5px'" />
                </Link>
            </div>
            <div
                id="app-bar-middle"
                class="flex-wrap"
                :style="{'margin-top': $vuetify.display.md ? `${infoHeight}px` : ''}"
            >
                <slot name="append"></slot>
            </div>
            <div
                id="app-bar-right"
                class="justify-end"
                :style="{'margin-top':( $vuetify.display.mdAndDown ? `${infoHeight}px` : ''),'height': ($page.props.infobar?.text && $vuetify.display.smAndDown) ? `50px` : 'auto'}"
            >
                <div class="d-flex align-center justify-end flex-grow-1 align-self-stretch">

                    <my-account
                        :info-bar-height="infoHeight"
                    ></my-account>
                    <v-btn
                        class="head-btn h-100"
                        id="app-bar-cart"
                        :class="{
                        overlayed: floatingCardModel,
                        'rounded-b-0 rounded-t-lg': floatingCardModel && $vuetify.display.lgAndUp,
                        'rounded-0': floatingCardModel && $vuetify.display.mdAndDown
                    }"
                        @mouseenter="handleCartDebounce"
                        @mouseleave="destroyCartDebounce"
                        @click="() => {
                            if($vuetify.display.mdAndDown) {
                                if(floatingCardModel) {
                                    handleCart(false);
                                    router.visit(route('order.cart'))
                                } else {
                                    handleCart(true);
                                }
                            } else {
                                handleCart(false);
                                router.visit(route('order.cart'))
                            }
                        }"
                    >
                        <v-badge left color="green" :content="cartItemsLength">
                            <v-icon :icon="mdiCartOutline" size="x-large" />
                        </v-badge>
                        <span v-show="$vuetify.display.mdAndUp"
                              class="text-body-2 font-weight-thin mt-1">{{ $t('app-bar.cart') }}</span>
                    </v-btn>
                    <floating-cart
                        :model-value="floatingCardModel"
                        @update-menu="handleCart($event)"
                    ></floating-cart>
                    <v-btn
                        v-show="$vuetify.display.mdAndDown"
                        class="h-100 bg-orange text-white pl-0 pr-2"
                        rounded="0"
                        @click="emit('mobileMenuState', !props.mobileMenuOpen)"
                    >
                        <v-icon :icon="menuIcon" size="large" color="white" class="ml-3 mr-2" />
                        <div>{{ $t('app-bar.menu') }}</div>
                    </v-btn>
                </div>
            </div>
        </v-app-bar-title>
    </v-app-bar>
</template>

<script setup>
import { computed, inject, ref, watch, nextTick, toRaw, onMounted } from 'vue';
import { Link, router, usePage } from '@inertiajs/vue3';
import {
    mdiCartOutline,
    mdiChevronDown,
    mdiClose, mdiCloudUploadOutline, mdiContentSaveOutline, mdiEyeOffOutline, mdiEyeOutline,
    mdiMenu,
    mdiPhoneOutline,
} from '@mdi/js';
import { useDisplay } from 'vuetify';
import { useElementSize } from '@vueuse/core';
import 'swiper/css';
import 'swiper/css/navigation';
import { useCartStore } from '../../../modules/eshop/store/cart';
import pinia from '../../../plugins/pinia';
import FloatMenu from './FloatMenu.vue';
import { useOverlayStore } from './store/overlay';
import MyAccount from './MyAccount.vue';
import FloatingCart from './FloatingCart.vue';
import InfoBar from '../../../motonet/modules/eshop/frontend/InfoBar.vue';
import priceHiderStore from '../../../../../Modules/Eshop/Resources/js/composables/priceHiderStore.js';

const priceHider = priceHiderStore(pinia);

const infoBarRef = ref(null);
const { height: infoHeight } = useElementSize(infoBarRef, { width: 0, height: 0 });

const cartDebounceTimeoutId = ref()

const handleCartDebounce = () => {
    if (cartDebounceTimeoutId.value) {
        clearTimeout(cartDebounceTimeoutId.value);
    }
    cartDebounceTimeoutId.value = setTimeout(() => {
        handleCart(true)
    }, 250)
}

const destroyCartDebounce = () => {
    clearTimeout(cartDebounceTimeoutId.value);
    cartDebounceTimeoutId.value = null;
}

const menuView = computed({
    get: () => {
        if (overlayStore.productDialog) {
            return false;
        }
        return overlayStore.navigationMenu;
    },
    set: (val) => overlayStore.navigationMenu = val
})

const props = defineProps({
    menu: Array,
    menuModel: Array,
    activeMenu: Object,
    mobileMenuOpen: Boolean,
});

const menuModel = ref(structuredClone(toRaw(props.menuModel)));

watch(() => props.menuModel, val => {
    menuModel.value = val;
});

const scrolledToTop = ref(true);

const scrollToTop = () => {
    if (!scrolledToTop.value && !menuAttachment.value.floating)
        window.scrollTo(0, 0);
};

const sideMenu = computed(() => Object.values(usePage().props.menu.topMenu).sort((a,b) => a.sort - b.sort).map(el => {
    return {
        link: el.url,
        title: el.title,
    }
}));

const floatingCardModel = ref(false);
const menuIcon = computed(() => {
    if (props.mobileMenuOpen)
        return mdiClose;
    return mdiMenu;
});

const handleCart = (open) => {
    if (!usePage().props.isOrdersRoute && open) {
        floatingCardModel.value = true;
        overlayStore.overlayMenu = true;
    } else {
        floatingCardModel.value = false;
        overlayStore.overlayMenu = false;
    }
};

const floatMenuObj = {
    attached: undefined,
    keepOpen: false,
    hoverOpen: false,
    persistent: false,
    floating: true,
    animate: 'slide-y-transition',
};
const homePageObj = {
    attached: undefined,
    keepOpen: true,
    hoverOpen: false,
    persistent: true,
    floating: true,
    animate: 'slide-y-transition',
};
const cartStore = useCartStore(pinia);
const overlayStore = useOverlayStore(pinia);
const route = inject('route');

const menuRefreshKey = ref(0);
const emit = defineEmits(['mobileMenuState', 'closeLeftDrawer', 'closeRightDrawer', 'infoBar']);
const appBar = ref(null);
const listMenu = ref(null);

watch(infoHeight, val => {
    emit('infoBar', val);
});
const overlayHide = (val) => {
    if (!val) {
        overlayStore.setMenuOverlay(false);
    }
};

const menuAttachment = ref(floatMenuObj);

watch(() => usePage().component, async (val) => {
    const groupId = usePage().props.group?.id;
    const component = val;
    await nextTick();
    menuAttachment.value = component === 'index' ? homePageObj : floatMenuObj;
    menuRefreshKey.value = groupId ? groupId : component === 'index' ? 999 : 0;
    await nextTick();
    if (component === 'index' && lgAndUp.value) {
        setTimeout(() => {
            overlayStore.navigationMenu = true;
        }, 500);
    } else {
        overlayStore.navigationMenu = false;
    }
}, { immediate: true });

onMounted(() => {
    if (!import.meta.env.SSR) {
        window.addEventListener('resize', () => {
            if (usePage().component === 'index') {
                if (lgAndUp.value && window.scrollY < 64 && !usePage().props.addToCart)
                    overlayStore.navigationMenu = true;
                else
                    overlayStore.navigationMenu = false;
            }
        });
        /*window.addEventListener('scroll', async () => {
            const groupId = usePage().props.group?.id;
            if (groupId) {
                if (window.scrollY > 340 && currentMenu.value === 'fixed') {
                    menuAttachment.value = floatMenuObj;
                    menuRefreshKey.value = Math.random() * 1000;
                    currentMenu.value = 'floating';
                    override.value = true;
                }
                if (window.scrollY <= 340 && currentMenu.value === 'floating') {
                    menuAttachment.value = fixedMenuObj;
                    menuRefreshKey.value = Math.random() * 1000;
                    currentMenu.value = 'fixed';
                    override.value = false;
                }
            }
        })*/
    }
});

const { width: appBarW } = useElementSize(appBar);
const { width: listW } = useElementSize(listMenu);

const subMenuWidth = computed(() => appBarW.value - listW.value);

const { lgAndUp } = useDisplay();
const cartItemsLength = computed(() => cartStore.cartItems.length.toString() || '0');
const shrink = ref(false);
const logo = computed(() => {
    const obj = {
        src: '/logo.png?max-width=200',
        alt: 'Logo',
    };
    const settingsLogo = usePage().props.logo;
    if (settingsLogo) {
        obj.src = `${settingsLogo.url}?max-width=800`;
        if (settingsLogo.alt) {
            obj.alt = settingsLogo.alt;
        }
    }
    return obj;
});

const onScroll = () => {
    if (window.scrollY < 30) {
        scrolledToTop.value = true;
    } else {
        scrolledToTop.value = false;
    }
    if (lgAndUp.value && Math.round(window.scrollY) >= 64) {
        shrink.value = true;
        if (usePage().component === 'index') {
            overlayStore.navigationMenu = false;
        }
        return;
    } else if (lgAndUp.value && usePage().component === 'index' && !usePage().props.addToCart) {
        if (!floatingCardModel.value) {
            overlayStore.navigationMenu = true;

        }
    }
    shrink.value = false;
};
</script>

<style lang="scss">
.c-app-bar__menu {
    &.c-floating-menu {
        > .v-overlay__content {
            //max-height: 60vh !important;
            @media (max-width: 1430px) {
                left: 0 !important;
            }
        }
    }

    //> .v-overlay__content {
    //    max-height: unset !important;
    //}
}
</style>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/components/VGrid/mixins' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use '/resources/css/variables' as v;
@use 'sass:map';

.c-shadow {
    box-shadow: 0 23px 97px -21px rgba(0,0,0,0.47)!important;
}

.shrink {
    :deep(.v-toolbar__content) {
        .v-toolbar-title {
            padding-bottom: 0 !important;
        }

        #app-bar-top {
            animation-name: disappear;
            animation-fill-mode: forwards;
            animation-duration: .1s;
        }
    }
}

@keyframes disappear {
    from {
        transform: translate3d(0, 0, 0);
    }
    to {
        transform: translate3d(0, -300px, 0);
        visibility: hidden;
        height: 0;
    }
}

.v-app-bar {

    :deep(.v-toolbar__content) {
        @include make-container-max-widths;
        & {
            max-width: v.$container-max-width !important;
            margin-inline: auto;
            transition-property: height, width, transform, max-width, left, right, top, bottom, box-shadow, opacity;
        }
    }

    :deep(.v-toolbar-title) {
        height: 100%;
        margin-inline-start: 0;

        &.simple {
            .v-toolbar-title__placeholder {
                grid-template-areas: 'left middle right';
                padding-bottom: 0;
                @media #{map.get($display-breakpoints, 'sm-and-down')} {
                    grid-template-rows: 1fr 0;
                }
            }
        }
    }

    :deep(.v-toolbar-title__placeholder) {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-areas: '. top top'
                             'left middle right';
        grid-template-columns: 1fr 3fr 1fr;
        column-gap: .5em;
        padding-bottom: 10px;
        @media #{map.get($display-breakpoints, 'md')} {
            grid-template-areas: "left middle right";
            padding-bottom: 0;
        }
        @media #{map.get($display-breakpoints, 'sm-and-down')} {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            grid-template-areas: "left right"
                                "middle middle";
            padding-bottom: 0;
            .v-input {
                --v-input-control-height: 40px;
                --v-input-padding-top: 11px;
            }
        }

        & > div {
            display: flex;
            align-items: center;
        }
    }

    :deep(.v-toolbar__extension) {
        display: flex;
        justify-content: center;
        background-color: map.get($grey, darken-2);
        color: white;
        //border-top: 1px solid rgba(0, 0, 0, 0.05);

        > div {
            @include make-container-max-widths;
            & {
                max-width: v.$container-max-width !important;
                display: grid;
                grid-template-columns: 305px auto auto;
                > div {
                    //border-right: 1px solid rgba(0, 0, 0, 0.05);

                    &:last-child {
                        //border-right: none;
                    }
                }
            }
        }
    }
}

:deep(.v-list-item-title) {
    .warning & {
        color: rgb(var(--v-theme-cis-accent-color)) !important;
    }
}

:deep(a:hover, a:focus, a:active) {
    .v-list-item-title {
        color: rgb(var(--v-theme-cis-accent-color));
    }
}

#app-bar-top {
    grid-area: top;
    @media #{map.get($display-breakpoints, 'md-and-down')} {
        display: none !important;
    }
}

#app-bar-logo {
    grid-area: left;

    > a {
        margin-inline-start: 16px;
    }
}

#app-bar-middle {
    grid-area: middle;
    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        border-top: 1px solid map.get($grey, lighten-2);
        :deep(.c-search-bikes) {
            .v-field__outline * {
                border: none !important;
            }
        }
        :deep(.main_search) {
            .v-field__outline * {
                border: none !important;
            }
        }
    }
}

#app-bar-right {
    grid-area: right;
}

:deep(.head-btn) {
    .v-btn__content {
        flex-direction: column;
    }

    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        .v-icon {
            font-size: 2.5em;
        }
    }
}

.v-icon.c-menu-icon {
    transition: transform .3s $standard-easing;

    &.rotate {
        transform: rotate3d(0, 0, 1, 180deg);
    }
}

#app-bar-cart {
    &.overlayed {
        z-index: 3000;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        background-color: white;

        :deep(.v-btn__overlay) {
            opacity: 0;
        }
    }
}
</style>
